import Cookies from 'js-cookie';

const DAYS_TIL_EXPIRATION = 30;

class ConsentStorage {
    set (key) {
        const now = (new Date()).toISOString();

        Cookies.set(key, now, { expires: DAYS_TIL_EXPIRATION });
    }
    get (key) {
        return Cookies.get(key);
    }
    remove (key, options = {}) {
        Cookies.remove(key, options);
    }
}

const consentStorage = new ConsentStorage();

export default consentStorage;


// WEBPACK FOOTER //
// ./assets/scripts/front/App/CookieConsent/Components/consentStorage.js